import type { ComponentProps, FC } from 'react';
import { createPortal } from 'react-dom';

import { AnnotationsOverlay } from '@/shared/graphics/RenderComponents/AnnotationsOverlay';

import { MPRAddToReport } from '@/features/MPR';

import type { FullHeadMprEditorPane } from '../../config';

type FullHeadMprSliceSessionPaneProps = {
  pane: FullHeadMprEditorPane;
  addToReport?: Pick<
    ComponentProps<typeof MPRAddToReport>,
    'isLoading' | 'isDisabled' | 'onAddToReport'
  >;
  className?: string;
  isAnnotationsHidden?: boolean;
};

export const FullHeadMprSliceSessionPane: FC<
  FullHeadMprSliceSessionPaneProps
> = ({ pane, addToReport, className, isAnnotationsHidden }) => (
  <>
    {createPortal(
      <AnnotationsOverlay
        className={className}
        annotations={isAnnotationsHidden ? [] : pane.annotations}
        widthPx={pane.snapshot.widthPx}
        heightPx={pane.snapshot.heightPx}
        scaleMmPerPixel={pane.snapshot.view.widthMm / pane.snapshot.widthPx}
        variant="editor"
      />,
      pane.surface,
      pane.projection,
    )}
    {addToReport && (
      <MPRAddToReport
        {...addToReport}
        attachTarget={pane.element}
        showFrame={false}
      />
    )}
  </>
);
